import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import moment from "moment";
import { useFormik } from "formik";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { setBreadCrumb } from "../../../middleware/actions/breadCrumbAction";
import {
  fetchGroupList,
  fetchPersonalizedUserListByPost,
  fetchPersonalizedViewListByPost,
  fetchPersonalizedViewAnalysisByUserByPost,
  fetchPersonalizedViewAnalysisByViewByPost,
  fetchPersonalizedViewAnalysisByConsumptionByPost,
} from "../../../middleware/services/reportApi";
import "./style.scss";
import { StringFilter } from "app/components/dataGrid/fliters";
import { hideLoader, showLoader, actionError } from "middleware/actions/utilityAction";
import TreeDataGridPersonalized from "app/components/treeDataGridPersonalized/index";
// import TreeDataGridNew from "app/components/treeDataGridNew";
import * as CONSTANTS from "../../../constants/index";
import { presets } from "utils";
import { Dropdown } from "../../components/CustomFormElements/syncFusionFormFields";
import { isAdmin } from "../../../utilities";
import { fetchTaxonomyTrend } from "middleware/services/cmsApi";
import { useHistory } from "react-router-dom";
import { PLATFORM_PERSONALIZATION_URL } from "../../../constants";
import CheckBoxGrouping from "../../components/CheckBoxGroupDropDown";
import { setRecordsPerPage, activePageInfo, skipRecords, setFilterParams } from "middleware/actions/gridAction";

let userCompetencyIndustry =
  localStorage.getItem("userCompetencyIndustry") !== "null" ? JSON.parse(localStorage.getItem("userCompetencyIndustry")) : [];

// specify breadcrumb here
const breadCrumbLinks = [{ linkUrl: "/report/internal-user", linkName: "Internal User Report", linkActive: true }];

const viewTypesDataSource = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Client View",
    value: "Client",
  },
  {
    label: "Default View",
    value: "Default",
  },
  {
    label: "Futurebridge View",
    value: "Futurebridge",
  },
];

const viewStatusDataSource = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Draft",
    value: "Draft",
  },
  {
    label: "Published",
    value: "Published",
  },
];

const activeStatusDataSource = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Yes",
    value: "YES",
  },
  {
    label: "No",
    value: "NO",
  },
];

// company dashboard component
const PersonalizedView = (props) => {
  const initialState = {
    reportIndustry: "All",
    reportGroup: "All",
    reportCreatedBy: "All",
    reportViewType: "All",
    reportViewStatus: "All",
    reportActive: "All",
  };
  const history = useHistory();
  const [dateRange, setDateRange] = useState(null);
  const [startDate, setStartDate] = useState(moment(new Date()).format("dd-MMM-yyyy"));
  const [endDate, setEndDate] = useState(moment(new Date()).format("dd-MMM-yyyy"));
  const [showSidePanel, setShowSidePanel] = useState(false);
  const [sideBarFilters, setSideBarFilters] = useState([]);
  const [gridRef, setGridRef] = useState(null);
  const [rowDataViewList, setRowDataViewList] = useState([]);
  const [rowDataViewListCount, setRowDataViewListCount] = useState(0);
  const [rowDataViewAnalysisByUser, setRowDataViewAnalysisByUser] = useState([]);
  const [rowDataViewAnalysisByUserCount, setRowDataViewAnalysisByUserCount] = useState(0);
  const [rowDataViewAnalysisByView, setRowDataViewAnalysisByView] = useState([]);
  const [rowDataViewAnalysisByViewCount, setRowDataViewAnalysisByViewCount] = useState(0);
  const [rowDataViewAnalysisByConsumption, setRowDataViewAnalysisByConsumption] = useState([]);
  const [rowDataViewAnalysisByConsumptionCount, setRowDataViewAnalysisByConsumptionCount] = useState(0);
  const sidebarRef = useRef(null);
  const dateRangeRef = useRef(null);
  const showLoaderGrid = () => dispatch(showLoader());
  const hideLoaderGrid = () => dispatch(hideLoader());
  const loading = useSelector((state) => state?.utilityState?.loading);
  const [groupDataSource, setGroupDataSource] = useState([]);
  const [createdByDataSource, setCreatedByDataSource] = useState([]);
  const [industryArray, setIndustryArray] = useState([]);
  const [radioSelectedValue, setRadioSelectedValue] = useState("personalized_view_list");
  const [personalizationGroup, setPersonalizationGroup] = useState("");
  const [personalizationIndustry, setPersonalizationIndustry] = useState("");
  const [personalizationCreatedName, setPersonalizationCreatedName] = useState("");
  const [industryDataValue, setIndustryDataValue] = useState([]);
  const [groupDataValue, setGroupDataValue] = useState([]);
  const [createdByDataValue, setCreatedByDataValue] = useState([]);
  const activePageNo = useSelector((state) => state?.gridState?.activePage);
  const pageSize = useSelector((state) => state?.gridState?.recordsPerPage);
  const gridState = useSelector((state) => state?.gridState);
  const [shouldFetch, setShouldFetch] = React.useState(false);
  const formik = useFormik({
    initialValues: {
      ...initialState,
    },
    // validationSchema: Yup.object().shape(fundingValidationSchema)
  });
  const dispatch = useDispatch();

  /**
   * Return Industry data based on user competency.
   *
   * @returns {Object[]}  - "Return the industry data".
   */
  const industrySource = useMemo(() => {
    if (isAdmin()) {
      const filterArray = industryArray.map((industry) => ({ label: industry.trendName, value: industry.trendName }));
      filterArray.unshift({ label: "All", value: "All" });
      return filterArray;
    }
    const uniqueIndustryNames = new Set();
    const industryList = userCompetencyIndustry
      .filter((industry) => {
        const industryName = industry.industryName;
        return !uniqueIndustryNames.has(industryName) && uniqueIndustryNames.add(industryName);
      })
      .map(({ industryName }) => ({ label: industryName, value: industryName }));
    // industryList.unshift({ label: "All", value: "All" });
    setIndustryDataValue(industryList.map((item) => item.value));
    return industryList;
  }, [userCompetencyIndustry, industryArray]);

  const groupsDataSource = useMemo(() => {
    const uniqueMap = new Map();

    (groupDataSource || []).forEach((group) => {
      if (!uniqueMap.has(group.groupName)) {
        uniqueMap.set(group.groupName, {
          label: group.groupName,
          value: group.groupName,
        });
      }
    });

    const groupData = Array.from(uniqueMap.values());

    const uniqueValues = groupData.map((item) => item.value);
    setGroupDataValue(uniqueValues);

    return groupData;
  }, [groupDataSource]);

  const createsByDataSource = useMemo(() => {
    const seen = new Set();
    const userData = [];

    (createdByDataSource || []).forEach((item) => {
      if (!seen.has(item.userName)) {
        seen.add(item.userName);
        userData.push({
          label: item.userName,
          value: item.userName,
        });
      }
    });

    setCreatedByDataValue(userData.map((i) => i.value));

    return userData;
  }, [createdByDataSource]);

  const toggleSidebar = (value, fieldName, keyword, groupName, groupNameHidden, industry, createdByName) => {
    let filters = [];
    if (keyword) filters.push(["search", "eq", keyword.split(",").map((word) => word.trim())]);
    else filters.push(["search", "eq", ""]);

    filters.push(["company", "eq", groupNameHidden]);

    filters.push(["fieldName", "eq", fieldName]);
    setSideBarFilters([...filters]);

    if (sidebarRef.current) {
      sidebarRef.current.hide();
    }
    setShowSidePanel(true);
    setPersonalizationGroup(groupName);
    setPersonalizationIndustry(industry);
    setPersonalizationCreatedName(createdByName);

    setTimeout(() => {
      setShowSidePanel(false);
    }, 500);
  };

  const fnStartDate = () => {
    let dateFrom = new Date();
    let dateTo = new Date();
    dateFrom.setDate(dateFrom.getDate() - CONSTANTS.ANALYTICS_REPORTS_DEFAULT_DATE_RANGE);
    const dateStart = dateFrom
      .toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");
    dateTo.setDate(dateTo.getDate());
    const dateEnd = dateTo
      .toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");
    setStartDate(new Date(dateStart));
    setEndDate(new Date(dateEnd));
    return [dateFrom, dateTo];
  };

  const fetchPersonalizedViewListDetails = async (reportDateRange, params = {}) => {
    try {
      showLoaderGrid();
      let filters = [];
      const dateFilter = dateRange === null ? (reportDateRange === null ? fnStartDate() : reportDateRange) : dateRange;

      if (industryDataValue.length > 0) {
        filters.push(["viewIndustry", "in", industryDataValue]);
      } else {
        const industryData = [];
        for (let i = 0; i < industrySource.length; i++) {
          industryData.push(industrySource[i].value);
        }
        filters.push(["viewIndustry", "in", industryData]);
      }
      if (Array.isArray(dateFilter) && dateFilter.length === 2) {
        const [startDate, endDate] = dateFilter;

        const gte = { d: moment(startDate).toISOString() };
        const lt = { d: moment(endDate).add(1, "day").toISOString() };

        filters.push(["createdOn", "gte", gte.d]);
        filters.push(["createdOn", "lt", lt.d]);
      }
      if (groupDataValue.length > 0) {
        filters.push(["viewGroupName", "in", groupDataValue]);
      }
      if (createdByDataValue.length > 0) {
        filters.push(["createdBy", "in", createdByDataValue]);
      }
      if (formik.values.reportViewType && formik.values.reportViewType !== "All") {
        filters.push(["type", "eq", formik.values.reportViewType]);
      }
      if (formik.values.reportViewStatus && formik.values.reportViewStatus !== "All") {
        filters.push(["viewStatus", "eq", formik.values.reportViewStatus]);
      }
      if (formik.values.reportActive && formik.values.reportActive !== "All") {
        filters.push(["isActive", "eq", formik.values.reportActive]);
      }
      if (params?.filters?.length > 0) {
        for (let i = 0; i < params.filters.length; i++) {
          filters.push(params.filters[i]);
        }
      } else if (gridState?.filtersParams?.length > 0) {
        for (let i = 0; i < gridState?.filtersParams.length; i++) {
          filters.push(gridState?.filtersParams[i]);
        }
      }

      // Extract isExport flag before building API params
      const isExport = params._isExport === true;
      delete params._isExport;

      params.filters = [...filters];
      if (!isExport) {
        if (!params?.limit) params.limit = 20;
        if (!params?.skip) params.skip = 0;
      }

      const data = await fetchPersonalizedViewListByPost({ ...params });

      if (!isExport) {
        setRowDataViewListCount(data?.data?.totalCount);
        setRowDataViewList(data?.data?.data ?? []);
      }

      hideLoaderGrid();
      return data;
    } catch (e) {
      console.error("fetchPersonalizedViewListDetailserror...", e);
      hideLoaderGrid();
    }
  };

  const fetchPersonalizedViewAnalysisByUserDetails = async (reportDateRange, params = {}) => {
    try {
      showLoaderGrid();
      let filters = [];
      const dateFilter = dateRange === null ? (reportDateRange === null ? fnStartDate() : reportDateRange) : dateRange;

      if (industryDataValue.length > 0) {
        filters.push(["viewIndustry", "in", industryDataValue]);
      } else {
        const industryData = [];
        for (let i = 0; i < industrySource.length; i++) {
          industryData.push(industrySource[i].value);
        }
        filters.push(["viewIndustry", "in", industryData]);
      }
      if (Array.isArray(dateFilter) && dateFilter.length === 2) {
        const [startDate, endDate] = dateFilter;

        const gte = { d: moment(startDate).toISOString() };
        const lt = { d: moment(endDate).add(1, "day").toISOString() };

        filters.push(["createdOn", "gte", gte.d]);
        filters.push(["createdOn", "lt", lt.d]);
      }
      if (groupDataValue.length > 0) {
        filters.push(["viewGroupName", "in", groupDataValue]);
      }
      if (createdByDataValue.length > 0) {
        filters.push(["createdBy", "in", createdByDataValue]);
      }
      if (params?.filters?.length > 0) {
        for (let i = 0; i < params.filters.length; i++) {
          filters.push(params.filters[i]);
        }
      } else if (gridState?.filtersParams?.length > 0) {
        for (let i = 0; i < gridState?.filtersParams.length; i++) {
          filters.push(gridState?.filtersParams[i]);
        }
      }

      params.filters = [...filters];
      if (!params?.limit) {
        params.limit = 20;
      }
      if (!params?.skip) {
        params.skip = 0;
      }

      let data = await fetchPersonalizedViewAnalysisByUserByPost({ ...params });
      setRowDataViewAnalysisByUserCount(data?.data?.totalCount);
      setRowDataViewAnalysisByUser(data?.data?.data ?? []);
      hideLoaderGrid();
      return data;
    } catch (e) {
      console.error("fetchPersonalizedViewAnalysisByUserDetailserror...", e);
      hideLoaderGrid();
    }
  };

  const fetchPersonalizedViewAnalysisByViewDetails = async (reportDateRange, params = {}) => {
    try {
      showLoaderGrid();
      let filters = [];
      const dateFilter = dateRange === null ? (reportDateRange === null ? fnStartDate() : reportDateRange) : dateRange;

      if (industryDataValue.length > 0) {
        filters.push(["viewIndustry", "in", industryDataValue]);
      } else {
        const industryData = [];
        for (let i = 0; i < industrySource.length; i++) {
          industryData.push(industrySource[i].value);
        }
        filters.push(["viewIndustry", "in", industryData]);
      }
      if (Array.isArray(dateFilter) && dateFilter.length === 2) {
        const [startDate, endDate] = dateFilter;

        const gte = { d: moment(startDate).toISOString() };
        const lt = { d: moment(endDate).add(1, "day").toISOString() };

        filters.push(["createdOn", "gte", gte.d]);
        filters.push(["createdOn", "lt", lt.d]);
      }
      if (groupDataValue.length > 0) {
        filters.push(["viewGroupName", "in", groupDataValue]);
      }
      if (createdByDataValue.length > 0) {
        filters.push(["createdBy", "in", createdByDataValue]);
      }
      if (formik.values.reportViewType && formik.values.reportViewType !== "All") {
        filters.push(["type", "eq", formik.values.reportViewType]);
      }
      if (params?.filters?.length > 0) {
        for (let i = 0; i < params.filters.length; i++) {
          filters.push(params.filters[i]);
        }
      } else if (gridState?.filtersParams?.length > 0) {
        for (let i = 0; i < gridState?.filtersParams.length; i++) {
          filters.push(gridState?.filtersParams[i]);
        }
      }

      params.filters = [...filters];
      if (!params?.limit) {
        params.limit = 20;
      }
      if (!params?.skip) {
        params.skip = 0;
      }

      let data = await fetchPersonalizedViewAnalysisByViewByPost({ ...params });
      setRowDataViewAnalysisByViewCount(data?.data?.totalCount);
      setRowDataViewAnalysisByView(data?.data?.data ?? []);
      hideLoaderGrid();
      return data;
    } catch (e) {
      console.error("fetchPersonalizedViewAnalysisByUserDetailserror...", e);
      hideLoaderGrid();
    }
  };

  const fetchPersonalizedViewAnalysisByConsumptionDetails = async (reportDateRange, params = {}) => {
    try {
      showLoaderGrid();
      let filters = [];
      const dateFilter = dateRange === null ? (reportDateRange === null ? fnStartDate() : reportDateRange) : dateRange;

      if (industryDataValue.length > 0) {
        filters.push(["viewIndustry", "in", industryDataValue]);
      } else {
        const industryData = [];
        for (let i = 0; i < industrySource.length; i++) {
          industryData.push(industrySource[i].value);
        }
        filters.push(["viewIndustry", "in", industryData]);
      }
      if (Array.isArray(dateFilter) && dateFilter.length === 2) {
        const [startDate, endDate] = dateFilter;

        const gte = { d: moment(startDate).toISOString() };
        const lt = { d: moment(endDate).add(1, "day").toISOString() };

        filters.push(["createdOn", "gte", gte.d]);
        filters.push(["createdOn", "lt", lt.d]);
      }
      if (groupDataValue.length > 0) {
        filters.push(["viewGroupName", "in", groupDataValue]);
      }
      if (createdByDataValue.length > 0) {
        filters.push(["createdBy", "in", createdByDataValue]);
      }
      if (formik.values.reportViewType && formik.values.reportViewType !== "All") {
        filters.push(["type", "eq", formik.values.reportViewType]);
      }
      if (formik.values.reportViewStatus && formik.values.reportViewStatus !== "All") {
        filters.push(["viewStatus", "eq", formik.values.reportViewStatus]);
      }
      if (params?.filters?.length > 0) {
        for (let i = 0; i < params.filters.length; i++) {
          filters.push(params.filters[i]);
        }
      } else if (gridState?.filtersParams?.length > 0) {
        for (let i = 0; i < gridState?.filtersParams.length; i++) {
          filters.push(gridState?.filtersParams[i]);
        }
      }

      params.filters = [...filters];
      if (!params?.limit) {
        params.limit = 20;
      }
      if (!params?.skip) {
        params.skip = 0;
      }

      let data = await fetchPersonalizedViewAnalysisByConsumptionByPost({ ...params });
      setRowDataViewAnalysisByConsumptionCount(data?.data?.totalCount);
      setRowDataViewAnalysisByConsumption(data?.data?.data ?? []);
      hideLoaderGrid();
      return data;
    } catch (e) {
      console.error("fetchPersonalizedViewAnalysisByUserDetailserror...", e);
      hideLoaderGrid();
    }
  };

  const rowDataBound = (args) => {
    if (args.data.level == 0) {
      // args.row.childNodes[0].style.fontWeight = "600";
    }
    (args.row?.childNodes[0]).style.fontSize = "14px";
    (args.row?.childNodes[0]).style.textAlign = "center";

    const rowIndex = parseInt(args.row.getAttribute("aria-rowIndex"));
    const currentPageNumber = activePageNo;
    const pageSizeNo = pageSize;
    const startIndex = (currentPageNumber - 1) * pageSizeNo;
    args.row.querySelector(".e-rowcell").innerHTML = (startIndex + rowIndex + 1).toString();
  };

  const recordsTemplate = (value) => {
    const a = value[`${value.column.field}`];
    return a ? (
      <span
        className={value.keyword === "" ? "span-link-color span-link-weight" : "span-link-color"}
        onClick={() =>
          toggleSidebar(
            a,
            value.column.field,
            value["keyword"],
            value["viewGroupName"],
            value["taskData"]["groupNameHidden"],
            value["viewIndustry"],
            value["createdBy"]
          )
        }
      >
        {a}
      </span>
    ) : (
      <span className={value.keyword === "" ? "span-link-weight" : ""}>{a}</span>
    );
  };

  const recordAndTimeTemplate = (value) => {
    const a = value[`${value.column.field}`];
    return a ? (
      <span
        className={value.keyword === "" ? "span-link-color span-link-weight" : "span-link-color"}
        onClick={() =>
          toggleSidebar(
            a,
            value.column.field,
            value["keyword"],
            value["viewGroupName"],
            value["taskData"]["groupNameHidden"],
            value["viewIndustry"],
            value["createdBy"]
          )
        }
      >
        {timeTemplate(a)}
      </span>
    ) : (
      <span className={value.keyword === "" ? "span-link-weight" : ""}>{timeTemplate(a)}</span>
    );
  };

  const timeInTextTemplate = (value) => {
    const a = value[`${value.column.field}`];
    return (
      <span className={value.keyword === "" ? "span-link-weight" : ""}>{timeTemplate(a)}</span>
    );
  };

  const timeTemplate = (seconds) => {
  if (!seconds && seconds !== 0) return <span>0 min</span>;

  const mins = Math.floor(seconds / 60);
  const secs = Math.round(seconds % 60);

  if (mins === 0 && secs !== 0) {
    return <span>{secs} sec</span>;
  } else if (secs === 0) {
    return <span>{mins} min</span>;
  } else {
    return (
      <span>
        {mins} min {secs} sec
      </span>
    );
  }
};

  const recordsTemplateContentTypeReport = (value) => {
    const viewIndustry = encodeURIComponent(value.viewIndustry);

    const viewContentType = encodeURIComponent(value.contentType);

    const a = value[`${value.column.field}`];
    return a ? (
      <span
        className={value.keyword === "" ? "span-link-color span-link-weight" : "span-link-color"}
        onClick={() => window.open(`/reports/content-type-analysis?industry=${viewIndustry}&contentType=${viewContentType}`, "_blank")}
      >
        {timeTemplate(a)}
      </span>
    ) : (
      <span className={value.keyword === "" ? "span-link-weight" : ""}>{timeTemplate(a)}</span>
    );
  };

  const columnFieldsViewList = [
    {
      field: "viewName",
      headerText: "View Name",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "200px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "createdBy",
      headerText: "Created By",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "createdOn",
      headerText: "Configured On",
      type: "date",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      clipMode: "EllipsisWithTooltip",
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "numberOfUsers",
      headerText: "No. Of Users Having Rights",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "100px",
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "lastAccessedOn",
      headerText: "Last Accessed On",
      type: "date",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "viewGroupName",
      headerText: "Group",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "viewIndustry",
      headerText: "Industry",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "viewPinned",
      headerText: "Pinned View",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "120px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "isActive",
      headerText: "Active",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "100px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "notificationActivated",
      headerText: "Notification Activated",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "type",
      headerText: "Type",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "100px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "taxonomy",
      headerText: "Taxonomy",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "tags",
      headerText: "Tags",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "120px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "savedSearchKeywords",
      headerText: "Saved Search Keywords",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "180px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "pinnedContent",
      headerText: "Pinned Content",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "lastRefreshDate",
      headerText: "Last Refresh Date",
      type: "date",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      allowFiltering: true,
      allowSorting: true,
      clipMode: "EllipsisWithTooltip",
    },
    {
      field: "btb",
      headerText: "BTB",
      type: "Number",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "100px",
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "timeSpent",
      headerText: "Time Spent on View (Min)",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "120px",
      allowFiltering: true,
      allowSorting: true,
      template: timeInTextTemplate
    },
    {
      field: "insight",
      headerText: "Insight, Reports & Research",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "140px",
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "webinar",
      headerText: "Webinar, Interview & Podcast (Count)",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "160px",
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "company",
      headerText: "Profile - Company & Technology (Count)",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "180px",
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "news",
      headerText: "Development & News (Count)",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "150px",
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "totalContent",
      headerText: "Total Content In View",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "140px",
      allowFiltering: true,
      allowSorting: true,
    },
  ];

  const columnFieldsViewAnalysisByUser = [
    {
      field: "viewGroupName",
      headerText: "Group",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "20%",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: false,
    },
    {
      field: "viewName",
      headerText: "View Name",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "20%",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "createdBy",
      headerText: "Created By",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "30%",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: false,
    },
    {
      field: "numberOfViews",
      headerText: "No. Of Views",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "15%",
      allowFiltering: true,
      allowSorting: true,
      template: recordsTemplate,
    },
    {
      field: "totalTimeSpent",
      headerText: "Time Spent On View (Min)",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "15%",
      allowFiltering: true,
      allowSorting: true,
      template: recordAndTimeTemplate,
    },
  ];

  const columnFieldsViewAnalysisByView = [
    {
      field: "viewIndustry",
      headerText: "Industry",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "18%",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: false,
    },
    {
      field: "viewGroupName",
      headerText: "Group",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "18%",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: false,
    },
    {
      field: "viewName",
      headerText: "View Name",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "20%",
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "createdBy",
      headerText: "Created By",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "16%",
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "totalContent",
      headerText: "Sum Of Total Content in Views",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "14%",
      allowFiltering: true,
      allowSorting: true,
    },
    {
      field: "timeSpent",
      headerText: "Total Time Spent on View (Min)",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "14%",
      allowFiltering: true,
      allowSorting: true,
      template: recordAndTimeTemplate,
    },
  ];

  const columnFieldsViewAnalysisByConsumption = [
    {
      field: "viewGroupName",
      headerText: "Group",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "12%",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "viewName",
      headerText: "View Name",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "12%",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "contentNameConsumed",
      headerText: "Content Consumed",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "10%",
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "insight",
      headerText: "Insight, Reports & Research",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "13%",
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "company",
      headerText: "Profile, Company & Technology",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "14%",
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "webinar",
      headerText: "Webinar, Interview & Podcats",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "13%",
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "totalContent",
      headerText: "Grand Total Of Contents",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "11%",
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "timeSpent",
      headerText: "Time Spent on View (Min)",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      width: "15%",
      allowFiltering: true,
      allowSorting: true,
      template: recordsTemplateContentTypeReport,
      showInColumnChooser: true,
    },
  ];

  const radioButtonDataSource = [
    {
      value: "personalized_view_list",
      name: "Personalized View List",
      data: rowDataViewList,
      columns: columnFieldsViewList,
    },
    {
      value: "personalized_view_analysis_user",
      name: "Personalized View Analysis By User",
      data: rowDataViewAnalysisByUser,
      columns: columnFieldsViewAnalysisByUser,
    },
    {
      value: "personalized_view_analysis_view",
      name: "Personalized View Analysis By View",
      data: rowDataViewAnalysisByView,
      columns: columnFieldsViewAnalysisByView,
    },
    {
      value: "personalized_view_analysis_consumption",
      name: "Personalized View Analysis By Consumption",
      data: rowDataViewAnalysisByConsumption,
      columns: columnFieldsViewAnalysisByConsumption,
    },
  ];

  const reportFetchers = {
    personalized_view_list: fetchPersonalizedViewListDetails,
    personalized_view_analysis_user: fetchPersonalizedViewAnalysisByUserDetails,
    personalized_view_analysis_view: fetchPersonalizedViewAnalysisByViewDetails,
    personalized_view_analysis_consumption: fetchPersonalizedViewAnalysisByConsumptionDetails,
  };

  const reportFetchersCount = {
    personalized_view_list: rowDataViewListCount,
    personalized_view_analysis_user: rowDataViewAnalysisByUserCount,
    personalized_view_analysis_view: rowDataViewAnalysisByViewCount,
    personalized_view_analysis_consumption: rowDataViewAnalysisByConsumptionCount,
  };

  const fetchAssignData = () => {
    dispatch(showLoader());

    let params = {};
    let userDataId = [];
    params.filters = [["viewCreatedByUserId", "neq", null]];
    params.limit = 1000;
    params.skip = 0;
    params.fields = ["viewCreatedByUserId", "viewCreatedByUserName"];

    fetchPersonalizedUserListByPost(params)
      .then((res) => {
        userDataId = res.data.data.map((d) => {
          return { userName: d.viewCreatedByUserName, userId: d.id };
        });
        setCreatedByDataSource(userDataId);

        // setTimeout(() => {
        //     dispatch(hideLoader());
        // }, [700]);
      })
      .catch(() => {
        dispatch(hideLoader());
        dispatch(actionError("Something went wrong...!"));
      });
  };

  const fetchGroups = useCallback(async () => {
    try {
      const response = await fetchGroupList();
      setGroupDataSource(response.data.data);

      let params = {
        fields: ["id", "trendName"],
        filters: [["trendParentId", "eq", 0]],
        sort: "trendName:asc",
      };
      const result = await fetchTaxonomyTrend(params);
      // let productIndustryIds = result.data.data.map((item) => item.id);
      setIndustryArray(result.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, []);

  const handleReset = () => {
    dispatch(setFilterParams([]));

    // Reset date picker to default range
    setDateRange(null);
    const [defaultStart, defaultEnd] = fnStartDate();
    if (dateRangeRef.current) {
      dateRangeRef.current.startDate = defaultStart;
      dateRangeRef.current.endDate = defaultEnd;
      dateRangeRef.current.dataBind();
    }

    if (industrySource?.length > 0) {
      setIndustryDataValue(industrySource.map((item) => item.value));
    }
    if (groupsDataSource?.length > 0) {
      setGroupDataValue(groupsDataSource.map((item) => item.value));
    }
    if (createsByDataSource?.length > 0) {
      setCreatedByDataValue(createsByDataSource.map((item) => item.value));
    }

    formik.setValues({
      ...formik.values,
      reportViewType: "All",
      reportViewStatus: "All",
      reportActive: "All",
    });

    setShouldFetch(true);
  };

  // useEffect(() => {
  //   if (industrySource?.length > 0) {
  //     setIndustryDataValue(industrySource.map((item) => item.value));
  //   }

  //   if (groupsDataSource?.length > 0) {
  //     setGroupDataValue(groupsDataSource.map((item) => item.value));
  //   }

  //   if (createsByDataSource?.length > 0) {
  //     setCreatedByDataValue(createsByDataSource.map((item) => item.value));
  //   }

  //   formik.values.reportViewType = "All";
  //   formik.values.reportViewStatus = "All";
  //   formik.values.reportActive = "All";

  //   fetchGroups();
  //   fetchAssignData();
  //   const reportDateRange = fnStartDate();

  //   reportFetchers[radioSelectedValue]?.(reportDateRange);
  // }, [radioSelectedValue]);

  useEffect(() => {
    fetchGroups();
    fetchAssignData();
  }, []);

  useEffect(() => {
    dispatch(setBreadCrumb(breadCrumbLinks));

    return () => {
      dispatch(setBreadCrumb());
    };
  }, [dispatch]);

  const getGridRef = (gridRefData) => {
    setGridRef(gridRefData);
  };

  const handlePersonalizationRedirect = () => {
    const enterpriseToken = localStorage.getItem("enterprise");
    const userId = localStorage.getItem("enterpriseUserId");
    const refreshToken = localStorage.getItem("refresh-token");
    const clientName = import.meta.env.VITE_ENTERPRISE_CLIENT_NAME;
    if (!userId || !enterpriseToken) return history.push("/login");
    if (enterpriseToken === "undefined" || !enterpriseToken || typeof enterpriseToken !== "string")
      return dispatch(actionError("Unable to access platform personalization."));

    window.open(
      PLATFORM_PERSONALIZATION_URL +
        "/auto-login?loginUserId=" +
        userId +
        "&clientName=" +
        clientName +
        "&token=" +
        enterpriseToken +
        "&refreshToken=" +
        refreshToken +
        "&group=" +
        encodeURIComponent(personalizationGroup) +
        "&industry=" +
        encodeURIComponent(personalizationIndustry) +
        "&createdBy=" +
        encodeURIComponent(personalizationCreatedName)
    );
  };

  return (
    <div className="px-3 grid-bg-white data-report-container">
      <div className="rounded-bottom bg-white ">
        <div className="d-flex gap-5">
          {radioButtonDataSource?.map((item, index) => (
            <div className="mt-3 mr-3">
              <Form.Check
                className="custom_radio"
                label={item.name}
                value={item.value}
                checked={item.value === radioSelectedValue}
                name={"status" + index}
                type="radio"
                key={`inline-radio-${index}`}
                id={`inline-radio-${index}`}
                onChange={(e) => {
                  setRadioSelectedValue(e.target.value);
                  dispatch(setRecordsPerPage(20));
                  dispatch(activePageInfo(1));
                  dispatch(skipRecords(0));
                }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="mt-3">
        <div className="row mr-0">
          <div className="col-md-3 mt-1">
            <CheckBoxGrouping
              mode="CheckBox"
              checkFields={{ text: "label", value: "value" }}
              placeholder="Industry"
              filterBarPlaceholder="Search Industry"
              selectedValues={industryDataValue}
              setSelectedValues={setIndustryDataValue}
              width="auto"
              dataSource={industrySource}
            />
          </div>
          <div className="col-md-3 mt-1 grid-container-report-filters keyword-search-report-datepicker">
            <DateRangePickerComponent
              ref={dateRangeRef}
              placeholder="Created On"
              cssClass="e-outline personalized-view-datepicker"
              openOnFocus={true}
              showClearButton={false}
              format="dd MMM yyyy"
              separator="to"
              floatLabelType="Auto"
              startDate={startDate}
              endDate={endDate}
              onChange={(e) => {
                if (e.value) setDateRange(e.value);
              }}
              autoComplete="off"
              max={new Date()}
              maxDays={CONSTANTS.KEYWORD_SEARCH_REPORT_DATE_RANGE_MAX}
              strictMode={true}
              presets={presets}
            />
          </div>
          <div className="col-md-3 mt-1">
            <CheckBoxGrouping
              mode="CheckBox"
              checkFields={{ text: "label", value: "value" }}
              placeholder="Group"
              filterBarPlaceholder="Search Group"
              selectedValues={groupDataValue}
              setSelectedValues={setGroupDataValue}
              width="auto"
              dataSource={groupsDataSource}
            />
          </div>
          <div className="col-md-3 mt-1">
            <CheckBoxGrouping
              mode="CheckBox"
              checkFields={{ text: "label", value: "value" }}
              placeholder="Created By"
              filterBarPlaceholder="Search Created By"
              selectedValues={createdByDataValue}
              setSelectedValues={setCreatedByDataValue}
              width="auto"
              dataSource={createsByDataSource}
            />
          </div>
          <div className="col-md-2 mt-3 pl-3">
            <Dropdown
              formik={formik}
              placeholder="View Type"
              required="required"
              id="reportViewType"
              name="reportViewType"
              fields={{ text: "label", value: "value" }}
              value={formik.values.reportViewType}
              dataSource={viewTypesDataSource}
              enabled={
                radioSelectedValue === "personalized_view_list" ||
                radioSelectedValue === "personalized_view_analysis_view" ||
                radioSelectedValue === "personalized_view_analysis_consumption"
              }
            />
          </div>
          <div className="col-md-2 mt-3 ">
            <Dropdown
              formik={formik}
              placeholder="View Status"
              required="required"
              id="reportViewStatus"
              name="reportViewStatus"
              fields={{ text: "label", value: "value" }}
              value={formik.values.reportViewStatus}
              dataSource={viewStatusDataSource}
              enabled={radioSelectedValue === "personalized_view_list" || radioSelectedValue === "personalized_view_analysis_consumption"}
            />
          </div>
          <div className="col-md-2 mt-3 pl-3">
            <Dropdown
              formik={formik}
              placeholder="Active"
              required="required"
              id="reportActive"
              name="reportActive"
              fields={{ text: "label", value: "value" }}
              value={formik.values.reportActive}
              dataSource={activeStatusDataSource}
              enabled={radioSelectedValue === "personalized_view_list"}
            />
          </div>
          <div className="col-md-3 mt-3">
            <button
              type="button"
              onClick={() => {
                // const reportDateRange = fnStartDate();
                // reportFetchers[radioSelectedValue]?.(reportDateRange);
                setShouldFetch(true);
                dispatch(activePageInfo(1));
                dispatch(setRecordsPerPage(20));
                dispatch(skipRecords(0));
                dispatch(setFilterParams([]));
                gridRef.current.clearFiltering();
                gridRef.current.clearSorting();
              }}
              className="search-btn px-4 btn btn-primary mr-2"
            >
              Search
            </button>
            <button type="reset" onClick={handleReset} className="btn btn-outline-dark px-4 ml-2 ">
              Reset
            </button>
          </div>
        </div>
      </div>

      <div className="personalized-report">
        {radioButtonDataSource.map((item, index) => {
          return radioSelectedValue === item.value ? (
            <div className="gennx-grid-client-detail-report analyst-query-report-grid">
              {groupDataSource.length > 0 && createdByDataSource.length > 0 && industryArray.length > 0 && (
                <TreeDataGridPersonalized
                  gridTitle={item.name}
                  fetch={reportFetchers[radioSelectedValue]}
                  // columns={columnNames}
                  columnFields={item.columns}
                  childMapping="subContent"
                  rowDataBound={rowDataBound}
                  isPaging={false}
                  // freezeColumn={2}
                  showResetFilter={true}
                  deleteMany={false}
                  showLoader={showLoaderGrid}
                  hideLoader={hideLoaderGrid}
                  getGridRef={getGridRef}
                  allowPagination={true}
                  showExportButton={true}
                  exportFileName={item.name}
                  setShouldFetch={setShouldFetch}
                  shouldFetch={shouldFetch}
                  radioSelectedValue={radioSelectedValue}
                  totalCount={reportFetchersCount[radioSelectedValue]}
                  // dataBound={dataBound}
                  // defaultSortingOptions={defaultSortingOptions}
                />
              )}
              {/* <NewPagination
                                rowData={item.data}
                                allowPagination={true}
                                showLoader={showLoaderGrid}
                                hideLoader={hideLoaderGrid}
                                totalCount={reportFetchersCount[radioSelectedValue]}
                                setRowData={item.data}
                                fetch={reportFetchers[radioSelectedValue]}
                                defaultPageView={CONSTANTS.DEFAULTANALYSTREPORTPAGEVIEW}
                            /> */}
            </div>
          ) : null;
        })}
      </div>

      {/* {!loading && !reportGetData[radioSelectedValue].length > 0 && <div className="noKeyPlayerImage">
                <Image src={emptyImage} alt="No data available" />
                <p style={{ fontSize: "15px", fontWeight: "bold" }}>No Data Available</p>
            </div>} */}

      {showSidePanel && handlePersonalizationRedirect()}
    </div>
  );
};

export default PersonalizedView;
